/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable arrow-body-style */
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Histroy = () => {
    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className='p-0'
                >
                    <div className='d-flex flex-column w-100'>
                    <div className="d-flex justify-content-between w-100">
                        <label className='fs-7'>Date</label>
                        <label className='fs-7'>Invoice No.</label>
                        <label className='fs-7'>Card No.</label>
                        <label className='fs-7'>Status</label>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                        <p className='fs-6 fw-bolder'>Jan 31, 2024</p>
                        <p><i><LinkIcon fontSize='small'/></i> in_1OeLc...</p>
                        <p>VISA •••• 3354.</p>
                        <p><i><CheckCircleIcon fontSize='small'color='success'/></i>SUCCEEDED</p>
                    </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                <div className='d-flex flex-column justify-content-between w-100'>
                    <div className="d-flex justify-content-start w-100">
                        <label className='fs-7 me-3'>Invoice Description</label>
                        <label className='fs-7'>Amount</label>
                    </div>
                    <div className="d-flex justify-content-start w-100">
                        <p className='fs-6 me-3'>Subscription...</p>
                        <p className='fw-bolder'>97 USD</p>
                    </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Histroy